const schedule = [
  {
    date: { day: "15", month: "JANEIRO", fulldate: "2024-01-15" },
    photo: "",
    description: "Prosa - Cambira - toda segunda-feira 20h",
  },
  {
    date: { day: "16", month: "JANEIRO", fulldate: "2024-01-16" },
    photo: "",
    description: "Prosa - Maringá - toda terça-feira 20h",
  },
  {
    date: { day: "20", month: "JANEIRO", fulldate: "2024-01-20" },
    photo: "",
    description: "Prosa - Londrina - toda sábado 18h",
  },
  {
    date: { day: "03", month: "FEVEREIRO", fulldate: "2024-02-03" },
    photo: "",
    description: "Treinamento de formação de Instrutores para o MPV",
  },
  {
    date: { day: "11", month: "FEVEREIRO", fulldate: "2024-02-11" },
    photo: "",
    description: "Comitiva Mapy (divulgação MPV)",
  },
  {
    date: { day: "17", month: "FEVEREIRO", fulldate: "2024-02-17" },
    photo: "2rSverNqkkFVmk8t7",
    description: "MPV Londrina-PR",
  },
  {
    date: { day: "24", month: "FEVEREIRO", fulldate: "2024-02-24" },
    photo: "",
    description: "Comitiva para Cornélio Procópio",
  },
  {
    date: { day: "09", month: "MARÇO", fulldate: "2024-03-09" },
    photo: "",
    description: "MPV Mulheres em Jandaia do Sul/Cambira",
  },
  {
    date: { day: "10", month: "MARÇO", fulldate: "2024-03-10" },
    photo: "",
    description: "Comitiva Mapy",
  },
  {
    date: { day: "23", month: "MARÇO", fulldate: "2024-03-23" },
    photo: "",
    description: "MPV Medianeira-PR",
  },
  {
    date: { day: "07", month: "ABRIL", fulldate: "2024-04-07" },
    photo: "",
    description: "Comitiva à igreja Geração com Palavra em Maringá - PR",
  },
  {
    date: { day: "14", month: "ABRIL", fulldate: "2024-04-14" },
    photo: "",
    description: "Comitiva Mapy",
  },
  {
    date: { day: "20", month: "ABRIL", fulldate: "2024-04-20" },
    photo: "",
    description: "MPV Medianeira-PR",
  },
  {
    date: { day: "04", month: "MAIO", fulldate: "2024-05-04" },
    photo: "",
    description: "Aniversário de 03 anos do MC",
  },
  {
    date: { day: "11", month: "MAIO", fulldate: "2024-05-11" },
    photo: "hTbg4kLGy1Z5Vgir6",
    description: "MPV Londrina - PR",
  },
  {
    date: { day: "19", month: "MAIO", fulldate: "2024-05-19" },
    photo: "",
    description: "Arena Mapy",
  },
  {
    date: { day: "30", month: "MAIO", fulldate: "2024-05-30" },
    photo: "",
    description: "Comitiva de casais",
  },
  {
    date: { day: "09", month: "JUNHO", fulldate: "2024-06-09" },
    photo: "",
    description: "Comitiva Igreja Metodista em Arapongas",
  },
  {
    date: { day: "15", month: "JUNHO", fulldate: "2024-06-15" },
    photo: "",
    description: "MPV Arapongas - PR",
  },
  {
    date: { day: "22", month: "JUNHO", fulldate: "2024-06-22" },
    photo: "",
    description: "MPV Medianeira-PR",
  },
  {
    date: { day: "06", month: "JULHO", fulldate: "2024-07-06" },
    photo: "",
    description: "MPV Jandaia do Sul/Cambira",
  },
  {
    date: { day: "28", month: "JULHO", fulldate: "2024-07-28" },
    photo: "",
    description: "Arena Mapy",
  },
  {
    date: { day: "03", month: "AGOSTO", fulldate: "2024-08-03" },
    photo: "",
    description: "MPV Maringá-PR",
  },
  {
    date: { day: "24", month: "AGOSTO", fulldate: "2024-08-24" },
    photo: "",
    description: "MPV Medianeira-PR",
  },
  {
    date: { day: "31", month: "AGOSTO", fulldate: "2024-08-31" },
    photo: "",
    description: "MPV Londrina-PR",
  },
  {
    date: { day: "21", month: "SETEMBRO", fulldate: "2024-09-21" },
    photo: "",
    description:
      "MPV Jandaia do Sul/Cambira (especial de 50 anos Auto Escola Jandaia)",
  },
  // {
  //   date: { day: "27", month: "SETEMBRO", fulldate: "2024-09-27" },
  //   photo: "",
  //   description: "BITES - Siqueira Campos",
  // },
  // {
  //   date: { day: "28", month: "SETEMBRO", fulldate: "2024-09-28" },
  //   photo: "",
  //   description: "BITES - Siqueira Campos",
  // },
  // {
  //   date: { day: "29", month: "SETEMBRO", fulldate: "2024-09-29" },
  //   photo: "",
  //   description: "BITES - Siqueira Campos",
  // },
  {
    date: { day: "06", month: "OUTUBRO", fulldate: "2024-10-06" },
    photo: "",
    description: "Arena Mapy",
  },
  {
    date: { day: "19", month: "OUTUBRO", fulldate: "2024-10-19" },
    photo: "",
    description: "MPV Maringá-PR",
  },
  {
    date: { day: "19", month: "OUTUBRO", fulldate: "2024-10-19" },
    photo: "",
    description: "MPV Medianeira-PR",
  },
  {
    date: { day: "09", month: "NOVEMBRO", fulldate: "2024-11-09" },
    photo: "",
    description: "MPV Londrina-PR",
  },
  {
    date: { day: "16", month: "NOVEMBRO", fulldate: "2024-11-16" },
    photo: "",
    description: "Comitiva Guarapuava (Jantar PMPR)",
  },
  {
    date: { day: "07", month: "DEZEMBRO", fulldate: "2024-12-07" },
    photo: "",
    description: "Confraternização de final de ano",
  },
];

export default schedule;
